import { useState } from 'react'
import { useIsomorphicLayoutEffect } from 'react-use'

import { useWishlistStore } from '@/store/wishlist'

import { Color } from '@/types'

export function useSSRWishlist() {
  const [wishlist, setWishlist] = useState<Color[]>([])

  useIsomorphicLayoutEffect(() => {
    const unsubscribe = useWishlistStore.subscribe((state) => state.wishlist, setWishlist, {
      fireImmediately: true
    })

    return () => {
      unsubscribe()
    }
  }, [])

  return wishlist
}
